import { useUserContext } from "@dexteel/mesf-core";
import { assetContext } from "../mill-config/mill-config";

export const useAssetId = (): number | undefined => {
	const {
		state: { defaultAreaId },
	} = useUserContext();

	const assetId =
		typeof defaultAreaId === "number"
			? defaultAreaId
			: typeof defaultAreaId === "string"
				? Number(defaultAreaId) || undefined
				: undefined;

	assetContext.setAssetId(assetId);

	return assetId;
};

export const useIsAssetIdReady = (): boolean => {
	const assetId = useAssetId();
	return assetId !== undefined;
};
